import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import es from '../locales/es/common.json';
import en from '../locales/en/common.json';

const LANGUAGE_STORAGE_KEY = 'app_language';
const supportedLanguages = ['es', 'en'] as const;

type SupportedLanguage = (typeof supportedLanguages)[number];

const normalizeLanguage = (language?: string | null): SupportedLanguage => {
  if (!language) return 'es';
  const lower = language.toLowerCase();
  if (lower.startsWith('en')) return 'en';
  if (lower.startsWith('es')) return 'es';
  return 'es';
};

const storedLanguage = typeof window !== 'undefined' ? localStorage.getItem(LANGUAGE_STORAGE_KEY) : null;
const browserLanguage = typeof navigator !== 'undefined' ? navigator.language : null;
const initialLanguage = normalizeLanguage(storedLanguage || browserLanguage);

i18n.use(initReactI18next).init({
  resources: {
    es: { translation: es },
    en: { translation: en },
  },
  lng: initialLanguage,
  fallbackLng: 'es',
  keySeparator: false,
  nsSeparator: false,
  interpolation: {
    escapeValue: false,
  },
  returnNull: false,
  returnEmptyString: false,
});

export const setLanguage = (language: string) => {
  const nextLanguage = normalizeLanguage(language);
  i18n.changeLanguage(nextLanguage);
  if (typeof window !== 'undefined') {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, nextLanguage);
  }
};

export default i18n;
